import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import TestimonialSection from "./components/TestimonialSection";
import CTASection from "./components/CTASection";
import FAQSection from "./components/FAQSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      {/* SEO Schema - FAQPage */}
      <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "How often is a fire risk assessment required in Singapore?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Under the Singapore Civil Defence Force (SCDF) regulations, fire risk assessments must be conducted annually for commercial and industrial buildings. Residential buildings under the Management Corporation Strata Title (MCST) are also required to conduct assessments every 2 years. Our team ensures your assessment meets all current SCDF and BCA requirements."
              }
            },
            {
              "@type": "Question",
              "name": "What documents do I need to submit for SCDF fire safety approval?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Required documents include: (1) Fire Safety Plan drawings showing escape routes, fire compartmentation, and fire-fighting provisions; (2) Fire Engine Access Route plans; (3) Material specifications for fire-rated doors and partitions; (4) Calculation sheets for occupant load and fire resistance ratings; (5) QP endorsement for structural fire safety. Upload all documents through our contact form for review."
              }
            },
            {
              "@type": "Question",
              "name": "How long does it take to install a fire alarm system in a commercial building?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Installation timelines vary by building size and system complexity. A small office (under 500 sqm) typically takes 2-3 days, while a large commercial complex may require 2-3 weeks. We provide detailed project timelines after the initial site survey and always work to minimize disruption to your daily operations."
              }
            },
            {
              "@type": "Question",
              "name": "Are your fire safety services SCDF-approved and BCA-registered?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, Ezzogenics is fully SCDF-registered and BCA-licensed. All our fire safety engineers and technicians hold relevant certifications including Fire Safety Manager accreditation, and our installations comply with SS CP 10 (Singapore Standard Code of Practice for Fire Alarm Systems) and SS 530 (Fire Extinguishing Systems)."
              }
            },
            {
              "@type": "Question",
              "name": "What areas in Singapore do you service?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide fire safety services across all districts in Singapore, including the Central Business District (CBD), Orchard, Tampines, Jurong, Woodlands, and all industrial estates. Our team is strategically located to respond to service calls across the island within 24 hours for emergency situations."
              }
            }
          ]
        }
        `}
      </script>

      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <TestimonialSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}